import { Box, Paper, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styles from "./InfoNotice.module.css";
import { Vocabulary } from "../Utils/Vocabulary";

interface InfoNoticeProps {
  message: string;
  showNoteLabel?: boolean;
}

/**
 * A component that displays a message with an optional label.
 *
 * @param {string} message - The message to be displayed.
 * @param {boolean} showNoteLabel - Whether to display the label.
 * @returns {JSX.Element} - A JSX element representing the info notice.
 */
function InfoNotice({ message, showNoteLabel = true }: InfoNoticeProps) {
  return (
    <Paper elevation={0} className={styles.noticeContainer}>
      <Box display="flex" alignItems="flex-start" gap={1.5}>
        <InfoOutlinedIcon className={styles.noticeIcon} color="primary" />
        <Typography variant="body1" color="text.secondary" sx={{ flex: 1, margin: 0 }}>
          {showNoteLabel && (
            <Box component="strong" color="primary.main">
              {Vocabulary.note}:{" "}
            </Box>
          )}
          {message}
        </Typography>
      </Box>
    </Paper>
  );
}

export default InfoNotice;
